/*
 * PWA bootstrap.
 *
 * Two responsibilities, both run from app JS on purpose:
 *   1. Register the service worker (production only — a SW would interfere with
 *      Vite's HMR in dev).
 *   2. Make sure the manifest + apple-touch-icon <link>s are present in <head>.
 *      The Base44 platform regenerates index.html on Publish and can strip
 *      custom head tags, so we re-inject them at runtime as a safety net. The
 *      tags also live statically in index.html for correct first-paint locally.
 *
 * This keeps "Add to Home Screen" working regardless of how index.html is
 * post-processed by the platform.
 */

function ensureLink(rel, href, attrs = {}) {
  const existing = document.querySelector(`link[rel="${rel}"]`);
  if (existing) return;
  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  for (const [key, value] of Object.entries(attrs)) link.setAttribute(key, value);
  document.head.appendChild(link);
}

function ensureMeta(name, content) {
  const existing = document.querySelector(`meta[name="${name}"]`);
  if (existing) return;
  const meta = document.createElement('meta');
  meta.setAttribute('name', name);
  meta.setAttribute('content', content);
  document.head.appendChild(meta);
}

function ensurePwaHeadTags() {
  ensureLink('manifest', '/manifest.webmanifest');
  ensureLink('apple-touch-icon', '/apple-touch-icon.png');
  ensureMeta('theme-color', '#4a2c1a');
  ensureMeta('apple-mobile-web-app-capable', 'yes');
  ensureMeta('apple-mobile-web-app-status-bar-style', 'default');
  ensureMeta('apple-mobile-web-app-title', 'Coffee Note');
  ensureMeta('mobile-web-app-capable', 'yes');
}

export function setupPWA() {
  if (typeof document === 'undefined') return;

  ensurePwaHeadTags();

  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Registration failures (e.g. unsupported context) should never break the app.
    });
  });
}
